<template>
  <section class="px-4 py-12 md:py-20">
    <div class="max-w-3xl mx-auto w-full flex flex-col items-center text-center gap-4">
      <h2 class="mb-0">{{ t('landing.cta.title') }}</h2>

      <div class="flex flex-col md:flex-row items-center gap-4">
        <VaButton size="large" :to="{ name: 'start' }">
          {{ t('landing.cta.submit') }}
        </VaButton>
        <VaButton
          size="large"
          preset="secondary"
          color="primary"
          border-color="primary"
          href="mailto:hello@mysoundz.ch"
        >
          {{ t('landing.cta.contact') }}
        </VaButton>
      </div>

      <p class="text-sm text-neutral-300 max-w-2xl mt-0">{{ t('landing.cta.note') }}</p>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import { VaButton } from 'vuestic-ui'

const { t } = useI18n()
</script>
